import React from 'react'
import {
  ProgressBar,
  ProgressBarProps
} from '@contrast-security-inc/design-system-data-bars'

export const LicenseThermometerSkeletor = ({
  size = 'lg',
  used,
  total,
  excess,
  testId,
  className,
  customLabel,
  LinkProps
}: Pick<
  ProgressBarProps,
  'size' | 'testId' | 'excess' | 'className' | 'customLabel' | 'LinkProps'
> & {
  used: ProgressBarProps['progress']
  total: number
}) => {
  return (
    <ProgressBar
      LinkProps={
        LinkProps && {
          ...LinkProps,
          testId: `${testId}-link`
        }
      }
      className={className}
      size={size}
      progress={{
        ...used,
        color: 'neutral60'
      }}
      total={{
        value: total
      }}
      excess={excess}
      testId={testId}
      labelType="footer"
      customLabel={customLabel}
    />
  )
}
